<template>
  <div class="topic-nav">
    <div class="left">
      <div class="index">
        <span v-if="!hideCurrentIndex">第{{ currentIndex }}题/</span>共{{
          total
        }}题
      </div>
      <div class="topic-type">
        <!-- <TopicDisplayType :t="T.type" /> -->
      </div>
      <div class="countdown" v-if="countdown">{{ countdown }}后自动交卷</div>
      <ul class="topics" v-if="T.index && T.index.length !== 1">
        <li
          :class="{ active: T.sonQuestion[i].userAnswer.length !== 0 }"
          v-for="(item, i) in T.index"
          @click="clickIndex(T.sonQuestion[i].questionId)"
          :key="item">
          {{ item }}
        </li>
      </ul>
    </div>
    <ul class="right">
<!--      <li v-if="canSeeAnswer" @click="$emit('seeAnswer')">查看答案</li>-->
      <li v-if="removeTopic" @click="$emit('removeTopic')">移除错题</li>
      <li @click="$emit('switchTopic', 0)">
        上一题
      </li>
      <li @click="$emit('switchTopic', 1)">
        下一题
      </li>
    </ul>
  </div>
</template>

<script>
// import TopicDisplayType from "./TopicDisplayType.vue";

export default {
  name: "TopicNav",
  props: {
    T: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hideCurrentIndex: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    canSeeAnswer: {
      type: Boolean,
      default: true
    },
    removeTopic: {
      type: Boolean,
      default: false
    },
    countdown: {
      type: String,
      default: ""
    }
  },
  computed: {
    currentIndex: function() {
      if (!this.T.hasOwnProperty("index")) return 0;
      let index = this.T.index;
      if (index.length === 1) {
        return index[0];
      }
      return index[0] + "~" + index[index.length - 1];
    }
  },
  methods: {
    clickIndex(id) {
      window.scrollTo(
        0,
        document.querySelector(`li[data-questionId="${id}"]`).offsetTop
      );
    }
  },
  mounted: function() {
    document.onkeyup = event => {
      let keyCode = event.which || event.keyCode;
      if (keyCode === 37) {
        this.$emit("switchTopic", 0);
        return;
      }
      if (keyCode === 39) {
        this.$emit("switchTopic", 1);
        return;
      }
      return;
    };
  },
  components: {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/var.scss";
.topic-nav {
  position: sticky;
  top: calc(#{$--nav-bar-height} + 20px);
  width: 100%;
  padding: 6px 0;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  z-index: 5;
  .left {
    flex: 1;
    display: flex;
    height: 100%;
    align-items: center;
    .index {
      color: #555360;
      font-size: 17px;
      font-weight: bold;
    }
    .topic-type {
      padding: 0 10px;
    }
    .countdown {
      color: #ff8f2b;
      font-size: 16px;
      margin-right: 10px;
      padding: 8px 10px;
      background-color: #fff0d3;
      border-radius: 3px;
    }
    .topics {
      display: flex;
      height: 100%;
      max-width: 250px;
      overflow-y: hidden;
      overflow-x: auto;
      margin: 0;
      padding: 0;
      align-items: center;
      li {
        cursor: pointer;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        border: 1px solid #969fa9;
        text-align: center;
        margin-right: 14px;
        line-height: 24px;
        font-size: 14px;
        color: #969fa9;
        list-style-type: none;
        &.active {
          border-color: #f2a536;
          color: #f2a536;
        }
      }
    }
  }
  .right {
    margin: 0;
    padding: 0;
    display: flex;
    height: 100%;
    align-items: center;
    li {
      list-style-type: none;
      color: #333333;
      border-left: 1px solid #333333;
      cursor: pointer;
      font-size: 14px;
      padding: 0 8px;
      &:first-child {
        border-left: none;
      }
      &:hover {
        color: $--color-primary;
      }
    }
  }
}
</style>
